import {getCheckedLang, getLang, LANG_KEY} from '@/services/langStorage';

import i18nEn from '@/lang/en/index';
import i18nTr from '@/lang/tr/index';
import i18nRu from '@/lang/ru/index';
import i18nKz from '@/lang/kz/index';
import i18nCn from '@/lang/cn/index';
import i18nUz from '@/lang/uz/index';
import i18nIn from '@/lang/in/index';
import i18nEs from '@/lang/es/index';

export const lang = getCheckedLang() || getLang(LANG_KEY) || 'en';
export const langChecked = getCheckedLang();

let messages: any;

if (lang === 'en') {
  messages = i18nEn;
} else if (lang === 'tr') {
  messages = i18nTr;
} else if (lang === 'kz') {
  messages = i18nKz;
} else if (lang === 'cn') {
  messages = i18nCn;
} else if (lang === 'uz') {
  messages = i18nUz;
} else if (lang === 'in') {
  messages = i18nIn;
} else if (lang === 'es') {
  messages = i18nEs;
} else {
  messages = i18nRu;
}

export const momentLang = lang === 'kz' ? 'kk' : (lang === 'cn') ? 'zh-cn' : (lang === 'uz') ? 'uz-latn' : (lang === 'in') ? 'pa-in' : lang;

export default messages;